import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" {...props}><path d="M.5 18.5h19L10 1 .5 18.5zm1.68-1h15.64L10 3.096 2.18 17.5z" /><path d="M9.5 12V7h1v5h-1zM10 16a1 1 0 110-2 1 1 0 010 2z" /></svg>;